import {GetSeferData}   from "SeferPetach/GetData";

export async function getData(obj) {
    var payload = await GetSeferData("rf7", obj);
    return (payload);
}
export async function getFilterMeta(){
    var payload = await GetSeferData("rfaux4", {});
    return (payload);
}
